<template>
  <div style="margin-top: 30px;">
    <el-container>
      <el-card style="position: fixed;border-radius: 8px" :body-style="{padding:'0px'}">
        <el-aside width="150px">
          <el-menu v-for="(item, index) in tagList" :key="item.page_id" :default-active="localTag" @select="onSelect"
                   style="margin-top: 0;">
            <el-menu-item class="title" :index="item.title" route="">{{ item.title }}</el-menu-item>
          </el-menu>
        </el-aside>
      </el-card>
      <div style="margin-left: 210px;display: flex;flex-direction: column;width: 100%">
        <el-card style="border-radius: 8px;width: 100%" :body-style="{padding:'0px'}">
          <div v-for="(item, index) in zxList" @click="onClick(item)">
            <div :class="index % 2 === 0 ? 'info_title_quiz' : 'info_title_quiz2'">
              <div
                style="margin-top:15px;display: flex;flex-direction: row;width: 100%;align-items: center;margin-bottom: 15px">
                <img style="width: 30px;height: 30px;border-radius: 50%" :src="item.userInfo.imageUrl"
                     :onerror="defaultImg">
                <a style="color: #666666;margin-left: 10px">{{ userCheck(item.userInfo.nickname) }}</a>
                <div style="color: #666666;margin-left: auto">{{ delTimeTag(item.commentTime) }}</div>
              </div>
              <div style="width: 100%;display: flex;flex-direction: row">
                <a style="color: #ffbc42; font-weight: bold;">{{ '[' + item.question_page_title + ']' }}</a>
                <a
                  style="color: #333333;margin-left: 5px;max-width: 860px; text-overflow: ellipsis; overflow: hidden;white-space: nowrap;font-size: 15px">{{
                    item.reviewContent
                  }}</a>
                <a v-if="item.hasAnswered === 1" style="color: #999999;margin-left:auto">{{ '(已回答)' }}</a>
              </div>
              <div v-if="item.subjectInfo.subjectDes"
                   style="background-color: #f2f2f2;color:#999999;border-radius: 8px;padding: 10px;margin-top: 10px;width: 100%;">
                {{ delHtmlTag(item.subjectInfo.subjectDes) }}
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-container>
    <div style="display: flex;flex-direction: column;align-items: center;margin-top: 50px">
      <el-pagination
        background
        :current-page="localNum"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="500">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getQuizData} from "../../networks/QuizRequestHandler"
import userPhoto from '../../common/imgs/default_icon.png'

export default {
  data() {
    return {
      zxList: [],
      tagList: [],
      localTag: '全部',
      localNum: 1,
      areasList: [],
    }
  },
  created: function () {
    this.getData(0)
  },
  computed: {
    defaultImg() {
      return 'this.src="' + userPhoto + '"';
    }
  },
  methods: {
    getData: function (index) {
      var context = this;
      var promise = getQuizData(0, 1);
      promise.then(function (r) {
        context.tagList = r.categories;
        var firstTag = {
          title: '全部',
          page_id: '0',
        }
        context.tagList.unshift(firstTag)
        console.log(context.areasList.length);
        context.zxList = r.questions;
        console.log(context.zxList)
      }).catch(function (error) {
      });
    },
    getArticleList: function (category_id, pageNum) {
      var context = this;
      var promise = getQuizData(category_id, pageNum);
      promise.then(function (r) {
        context.zxList = r.questions;
        console.log(context.zxList)
        var doc = document.body.scrollTop == 0 ? $(document.documentElement) : $('body');
        doc.animate({'scrollTop': 0});
      }).catch(function (error) {
      });
    },
    onSelect: function (index, indexPath) {
      let context = this;
      context.localTag = index;
      context.localNum = 1;
      var index = context.tagList.findIndex(item => item.title === index)
      context.getArticleList(context.tagList[index].page_id, 1)
    },
    handleCurrentChange: function (currentPage) {
      let context = this;
      context.localNum = currentPage;
      var index = context.tagList.findIndex(item => item.title === context.localTag)
      context.getArticleList(context.tagList[index].page_id, currentPage)
    },
    delHtmlTag: function (str) {
      return str.replace(/<[^>]+>/g, "");
    },
    delTimeTag: function (str) {
      return str.replace('T', " ");
    },
    userCheck: function (str) {
      if ($.isEmptyObject(str)) {
        str = '必胜用户'
      }
      return str
    },
    onClick: function (item) {
      this.$router.push({path: "/quiz/quiz_id/" + item.commentId})
      console.log(item.commentId)
    }
  }
};
</script>

<style>

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title_quiz {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title_quiz2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  padding-right: 10px;
  list-style: none;
}

.area_text_non {
  width: 50px;
  text-align: center;
}

.area_text {
  font-weight: bold;
  width: 50px;
  text-align: center;
  color: #ffbc42;
}


</style>



// WEBPACK FOOTER //
// src/components/Quiz/QuizHome.vue